import { Button, Flex, Text } from '@mantine/core';
import classes from './vacancy-list.module.scss';
import { VacancyCard } from '../vacancy-card';
import { IconArrowUpRight } from '@tabler/icons-react';
import { NavLink } from 'react-router';
import { getCityNames } from '@entities/region';

type VacancyListItem = {
  id: number;
  name: string;
  salaryFrom: number;
  salaryTo: number;
  createdAt: string;
  cities?: Array<{
    name: string;
  }>;
  city?: {
    name: string;
  } | null;
  currency?: {
    value: string;
  } | null;
  paymentPeriod?: {
    name: string;
  } | null;
};

type VacancyListProps = {
  title?: string;
  vacancies: VacancyListItem[];
  totalVacancies: number;
  viewAllHref?: string;
  isLoading?: boolean;
};

export const VacancyList = ({
  title = 'Релевантные вакансии',
  vacancies,
  totalVacancies,
  viewAllHref = '/vacancy-list',
  isLoading = false,
}: VacancyListProps) => {
  const isViewAllDisabled = isLoading;

  return (
    <Flex
      className={classes.wrapper}
      gap={24}
      direction='column'
      maw={418}
      miw={{ base: 'auto', sm: '25.5rem' }}
    >
      <Flex w='100%' justify='space-between' align='center' wrap='wrap'>
        <Text size='lg' fw={600}>
          {title}
        </Text>

        {isViewAllDisabled ? (
          <Button
            variant='subtle'
            rightSection={<IconArrowUpRight size={20} />}
            className={classes.allButton}
            disabled
          >
            {`Все (${totalVacancies})`}
          </Button>
        ) : (
          <Button
            variant='subtle'
            rightSection={<IconArrowUpRight size={20} />}
            className={classes.allButton}
            component={NavLink}
            to={viewAllHref}
          >
            {`Все (${totalVacancies})`}
          </Button>
        )}
      </Flex>

      <Flex direction='column' gap={12}>
        {vacancies.map(vacancy => (
          <VacancyCard
            key={vacancy?.id}
            id={vacancy?.id}
            name={vacancy?.name}
            region={getCityNames(vacancy)}
            salaryFrom={vacancy?.salaryFrom}
            salaryTo={vacancy?.salaryTo}
            currency={vacancy.currency?.value ?? ''}
            createdAt={vacancy?.createdAt}
            paymentPeriod={vacancy.paymentPeriod?.name ?? ''}
          />
        ))}

        {vacancies.length === 0 && !isLoading && (
          <Text size='sm' c='tertiary.7'>
            Нет вакансий
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
